import { computeInitials } from "../Avatars.logic";
import styles from "../Avatars.module.css";

type Props = {
  name: string;
  large?: boolean;
};

export default function AvatarInitials(props: Props) {
  const { name, large } = props;

  return (
    <div className={large ? styles.initialsLarge : styles.initials}>{computeInitials(name)}</div>
  );
}
